"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicClientEndpoint = exports.AuthenticatedClientEndpoint = void 0;
const Either = __importStar(require("fp-ts/Either"));
class BaseClientEndpoint {
    constructor(endpoint, clientOptions, endpointUrl) {
        this.doRequest = (requestBody) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield fetch(`${this.clientOptions.host}:${this.clientOptions.port}${this.endpointUrl}`, {
                    body: JSON.stringify(requestBody),
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                if (res.status !== 200) {
                    return {
                        success: false,
                        message: yield res.text(),
                        messageForUser: true,
                    };
                }
                //
                const json = yield res.json();
                const decodedRes = this.endpoint.responseCodec.decode(json);
                if (Either.isLeft(decodedRes)) {
                    throw Error("Invalid response from server - does not match specified response codec");
                }
                return {
                    success: true,
                    body: decodedRes.right,
                };
            }
            catch (e) {
                return {
                    success: false,
                    message: e.message,
                    messageForUser: false,
                };
            }
        });
        this.endpoint = endpoint;
        this.clientOptions = clientOptions;
        this.endpointUrl = endpointUrl;
    }
}
class AuthenticatedClientEndpoint extends BaseClientEndpoint {
    constructor(endpoint, clientOptions, endpointUrl) {
        super(endpoint, clientOptions, endpointUrl);
        this.send = (body, token) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequest({ token, body });
        });
    }
}
exports.AuthenticatedClientEndpoint = AuthenticatedClientEndpoint;
class PublicClientEndpoint extends BaseClientEndpoint {
    constructor(endpoint, clientOptions, endpointUrl) {
        super(endpoint, clientOptions, endpointUrl);
        this.send = (body) => __awaiter(this, void 0, void 0, function* () {
            return this.doRequest(body);
        });
    }
}
exports.PublicClientEndpoint = PublicClientEndpoint;
//# sourceMappingURL=ClientEndpoint.js.map